import useClassNames from '@medflex/hooks/useClassNames';
import PropTypes from 'prop-types';
import React from 'react';

const TitleBar = ({
  className,
  children,
  buttonLeft,
  buttonRight,
  height,
  'data-testid': dataTestId,
}) => {
  const cn = useClassNames(
    () => [
      'flex',
      'relative',
      'items-center',
      !height && 'h-16',
      height === 'lg' && 'h-16',
      height === 'sm' && 'h-12',
      className,
    ],
    [className, height],
  );
  return (
    <header data-component="TitleBar" className={cn} data-testid={dataTestId}>
      <div className="flex justify-start items-center flex-shrink-0 left-0 px-4 lg:absolute">
        {buttonLeft}
      </div>
      <div className="ml-2 font-semibold min-w-0 flex-shrink-0 flex-1 px-2 lg:text-center lg:justify-center flex items-center">
        {children}
      </div>
      <div className="flex justify-end items-center flex-shrink-0 mr-4 lg:absolute right-0">
        {buttonRight}
      </div>
    </header>
  );
};

TitleBar.propTypes = {
  className: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.func,
    PropTypes.array,
    PropTypes.object,
  ]),
  children: PropTypes.node,
  buttonLeft: PropTypes.node,
  buttonRight: PropTypes.node,
  height: PropTypes.oneOf(['sm', 'lg']),
  'data-testid': PropTypes.string,
};

export default TitleBar;
